exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".lba-group-columns{display:grid;column-gap:20px}.lba-group-columns h3{font-size:14px;font-weight:600;color:#555;margin:0 0 8px}.lba-group-columns .lba-group-column-header{font-size:14px;font-weight:600;color:#555;padding-bottom:4px}", "", {"version":3,"sources":["/../../../../../sassjs-loader/index.js!/home/vsts/work/1/s/src/components/lbaGroup/lbaGroup.scss"],"names":[],"mappings":"AAAA,mBACE,aAAc,AACd,eAAiB,CAAE,AACnB,sBACE,eAAgB,AAChB,gBAAiB,AACjB,WAAY,AACZ,cAAkB,CAAE,AACtB,4CACE,eAAgB,AAChB,gBAAiB,AACjB,WAAY,AACZ,kBAAoB,CAAE","file":"lbaGroup.scss","sourcesContent":[".lba-group-columns {\n  display: grid;\n  column-gap: 20px; }\n  .lba-group-columns h3 {\n    font-size: 14px;\n    font-weight: 600;\n    color: #555;\n    margin: 0 0 8px 0; }\n  .lba-group-columns .lba-group-column-header {\n    font-size: 14px;\n    font-weight: 600;\n    color: #555;\n    padding-bottom: 4px; }\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sassjs-loader!./src/components/lbaGroup/lbaGroup.scss
// module id = 211
// module chunks = 0